import React, { useEffect } from 'react';
import Alert from './alert';
import { useRouter } from 'next/router';
import useAlertProvider from './useAlertProvider';
import { IAlert } from './alertProvider';
import styles from './alert.module.scss';

const emptyAlerts: IAlert[] = [];

const PageAlerts = () => {
  const router = useRouter();
  const { alerts, setAlerts } = useAlertProvider();

  useEffect(() => {
    if (router.asPath && alerts?.length === 0) {
      setAlerts(emptyAlerts);
    }
  }, [router.asPath, setAlerts]);

  return (
    <div className={styles.alertsContainer}>
      {alerts.map((alert, i) => (
        <Alert
          key={i}
          title={alert.title}
          footerContent={alert.actions}
          error={alert.error}
          info={alert.info}
        >
          {alert.message}{' '}
          <a className={styles.link} href={alert.href}>
            {alert.link}
          </a>
          {alert.link ? '.' : ''}
        </Alert>
      ))}
    </div>
  );
};

export default PageAlerts;
